import { PackageShareSettingsUIModel } from "src/store/models/ui/shareSettings/packageShareSettings";
import { RobotShareSettingsUIModel } from "src/store/models/ui/shareSettings/robotShareSettings";

export const encooShareSettingsUIModels = {
  robotShare: RobotShareSettingsUIModel,
  packageShare: PackageShareSettingsUIModel,
};
